import ActivitiesSummary from "./ActivitiesSummary";

export default ActivitiesSummary;
